const { REACT_APP_URL, REACT_APP_UPLOAD_URL } = process.env;

const config = {
  API: REACT_APP_URL,
  UPLOAD: REACT_APP_UPLOAD_URL
};

export default config;
